import { render, staticRenderFns } from "./DryIceArrange.vue?vue&type=template&id=bbb80f88&scoped=true"
import script from "./DryIceArrange.vue?vue&type=script&lang=js"
export * from "./DryIceArrange.vue?vue&type=script&lang=js"
import style0 from "./DryIceArrange.vue?vue&type=style&index=0&id=bbb80f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb80f88",
  null
  
)

export default component.exports